module.exports = __webpack_public_path__ + "media/images/flags/32/Nagorno-Karabakh-228f07263118d0c676523c646b5222ca.png";